// extracted by mini-css-extract-plugin
module.exports = {"addButton":"profile_addButton__XnL3y"};